import { link } from 'settings/navigation/link';
import { openNewTab } from 'services/newTab';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.scss';
import { TRANSACTION_TABS } from '../helper';
import { tableColumns } from 'pages/Workshop/Transactions/components/TransactionsAndProjectsTable/tableColumns';
import { WorkshopTabsTable } from 'pages/Workshop/components/WorkshopTabsTable';
import { resetTransactionEffect } from 'store/effects';
import { useDispatch } from 'react-redux';

export const TransactionsTable = (props) => {
  const { userRole, dataSource, archivedValue, loading } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const closingColumnLabel =
    archivedValue === TRANSACTION_TABS.Closed
      ? 'Closed'
      : archivedValue === TRANSACTION_TABS.Cancelled
      ? 'Canceled'
      : archivedValue === TRANSACTION_TABS.Expired
      ? 'Expired'
      : '';

  const tableProps = {
    columns: tableColumns(userRole, closingColumnLabel, !!closingColumnLabel),
    onRow: (record) => {
      return {
        onClick: (e) => {
          const path = link.toTransactionOverview(record.Id);
          dispatch(resetTransactionEffect());
          if (e.ctrlKey || e.metaKey) {
            openNewTab(path);
          } else {
            history.push(path);
          }
        },
      };
    },
    tableClassName: styles.transactionsTable,
  };

  return (
    <WorkshopTabsTable
      {...tableProps}
      dataSource={dataSource}
      emptyText="No Transactions."
      loading={loading}
    />
  );
};
